import React, { Component } from "react";
import withRouter from "../../../Utils/withRouter";
 
 
import UpdatePayrollNavigationSideBar from "./UpdatePayrollNavigationSideBar";
import EmployeeList from "../EmployeeList";
class ManageEmployeeList extends Component {
  render() {
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title mb-0">Update Candidate</h4>
                  </div>
                  {/* end card header */}
                  <div className="card-body form-steps">
                    <div className="vertical-navs-step">
                      <div className="row gy-5">
                        <UpdatePayrollNavigationSideBar employee_id = {this.props.params.employee_id} />
                        {/* end col*/} 
                        <div className="col-lg-9">
                          <div className="px-lg-4">
                            <div className="tab-content">
                              <div
                                className="tab-pane fade show active"
                                id="v-pills-bill-info"
                                role="tabpanel"
                                aria-labelledby="v-pills-bill-info-tab"
                              >
                                <EmployeeList />
                                
                              </div>
                             
                              {/* end tab pane */}
                            </div>
                            {/* end tab content */}
                          </div>
                        </div>
                        {/* end col */}
                      </div>
                      {/* end row */}
                    </div>
                  </div>
                </div>
                {/* end */}
              </div>
              {/* end col */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ManageEmployeeList);
